import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const position = [13.0435171, 77.5204052];

export default function LocationMap() {
  return (
    <div className="map-section">

      <a
        className="direction-btn"
        href="https://www.google.com/maps/dir/?api=1&destination=13.0435171,77.5204052"
        target="_blank"
        rel="noreferrer"
      >
        📍 Get Direction
      </a>

      <MapContainer
        center={position}
        zoom={15}
        scrollWheelZoom={false}
        style={{ height: "500px", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker position={position}>
          <Popup>
            <strong>Aryan Comfort</strong>
            <br />
            A Unit of Ridhya Vistas
          </Popup>
        </Marker>
      </MapContainer>

    </div>
  );
}